<div class="success--container">
  <img src="/assets/img/icon_success.png" />
  <ng-container *ngIf="data?.isDefault; else receiptSuccess">
    <div class="success--title">{{ data.title }}</div>
    <div class="success--desc">{{ data.description }}</div>
    <div class="okay--btn" [mat-dialog-close]>
      {{ "common.close" | translate }}
    </div>
  </ng-container>
  <ng-template #receiptSuccess>
    <div class="success--title">{{ "common.success._!" | translate }}</div>
    <div class="success--desc" *ngIf="!data.edit">
      {{ "common.receipt.receiptSuccess" | translate }}
    </div>
    <div class="success--desc" *ngIf="data.edit">
      {{ "common.receipt.editReceiptSuccess" | translate }}
    </div>
    <div class="okay--btn" (click)="goToReceiptList()" [mat-dialog-close]>
      {{ "common.close" | translate }}
    </div>
  </ng-template>
</div>
